import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { pricingTiers } from '../../data/site';
export function PricingTiers() {
  return <ul className="mt-14 grid gap-8 lg:grid-cols-3" data-id="element-207" data-mp="1i4dcw4ekcx2t">
      {pricingTiers.map(tier => <li key={tier.name} className={`flex flex-col rounded-brand p-8 ${tier.accent ? 'bg-ink text-cream' : 'border border-ink/15 bg-cream-light'}`} data-id="element-208" data-mp="1d5sdg774yhff">
          <h3 className={`text-[0.6875rem] uppercase tracking-label ${tier.accent ? 'text-cream/70' : 'text-ink-muted'}`} data-id="element-209" data-mp="25uh93qpf9ujs">
            {tier.name}
          </h3>
          <p className="mt-6 flex items-baseline gap-2" data-id="element-210" data-mp="1vwtb8rwis6xe">
            <span className={`font-serif text-5xl ${tier.accent ? 'text-cream' : 'text-ink'}`} data-id="element-211" data-mp="1vye50fb0flu7">
              ${tier.price}
            </span>
            <span className={`text-sm ${tier.accent ? 'text-cream/70' : 'text-ink-muted'}`} data-id="element-212" data-mp="kglej73rrptn">
              {tier.cadence}
            </span>
          </p>
          <p className={`mt-5 text-sm leading-relaxed ${tier.accent ? 'text-cream/70' : 'text-ink-soft'}`} data-id="element-213" data-mp="13bd62xbu9uyw">
            {tier.description}
          </p>
          <ul className={`mt-8 flex flex-col gap-3 ${tier.accent ? '' : ''}`} data-id="element-214" data-mp="the541ni4h8j">
            {tier.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-215" data-mp="joowrfn8zjhf">
                <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${tier.accent ? 'text-cream/60' : 'text-brick'}`} strokeWidth={2} data-id="element-216" data-mp="jndslepw49ps" />
                <span className={`text-sm leading-relaxed ${tier.accent ? 'text-cream/80' : 'text-ink-soft'}`} data-id="element-217" data-mp="fndejv6pe0j9">
                  {feature}
                </span>
              </li>)}
          </ul>
          <Link to="/get-started" className={`group mt-auto inline-flex items-center gap-2 pt-10 text-sm ${tier.accent ? 'text-cream hover:text-cream/70' : 'text-brick hover:text-ink'} transition-colors duration-150 ease-republic`} data-id="element-218" data-mp="3iq89xmyziz91">
            Get started
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-219" data-mp="341u5x8pu14qw" />
          </Link>
        </li>)}
    </ul>;
}